import Reveal from "@/components/base/Reveal";

const STEPS = [
  {
    icon: "ri-edit-2-line",
    title: "You write it",
    text: "Tell your story in your own words — a memory, a farm visit, a family recipe, a season you'll never forget.",
  },
  {
    icon: "ri-eye-line",
    title: "We read it",
    text: "A real person on our editorial team reads every submission and reaches out if we'd love to feature it.",
  },
  {
    icon: "ri-book-open-line",
    title: "It joins the journal",
    text: "Once you approve, your story is published in Stories From the Soil for visitors around the world to read.",
  },
];

export default function ShareStorySteps() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-2xl mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 font-semibold">
            How a story gets published
          </h2>
          <p className="mt-4 text-base text-foreground-700 leading-relaxed">
            No gatekeeping, no jargon — just your words, thoughtfully looked after.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((step, index) => (
            <Reveal key={step.title} delay={index * 80}>
              <div className="h-full bg-background-50 border border-background-200 rounded-lg p-6 md:p-7">
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${step.icon} text-2xl`}></i>
                  </span>
                  <span className="font-heading text-3xl text-background-300 font-semibold">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-heading text-xl text-foreground-950 font-semibold mt-5">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}